import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=a8cf4668&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=a8cf4668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cf4668",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8cf4668')) {
      api.createRecord('a8cf4668', component.options)
    } else {
      api.reload('a8cf4668', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=a8cf4668&scoped=true&", function () {
      api.rerender('a8cf4668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R5hslHnGZwX0/JS/teamMember.vue"
export default component.exports